export class WebsocketConnectionException extends Error {
    constructor() {
        super("Cannot connect to the websocket");
    }
}
